import is from '@sindresorhus/is';
import type { Locale } from 'date-fns';
import { formatDistance, formatDistanceStrict } from 'date-fns';
import { isValid } from 'date-fns/isValid';
import Maybe from 'true-myth/maybe';
import { z } from 'zod';

const dateTime = z.string().datetime({ offset: true });

export const isValidDate = (date: string | null | undefined): date is string =>
    is.string(date) && isValid(new Date(date));

export const dateDistanceToNowAsText = (
    currentTimestamp: number,
    locale: Locale,
    dateStringFrom: string,
): Maybe<string> => {
    return dateTime
        .transform((date) =>
            Maybe.of(
                formatDistance(new Date(date), currentTimestamp, {
                    addSuffix: true,
                    locale,
                }),
            ),
        )
        .parse(dateStringFrom);
};

export const dateDistanceToNowStrictAsText = (
    currentTimestamp: number,
    locale: Locale,
    dateStringFrom: string,
): Maybe<string> => {
    return dateTime
        .transform((date) =>
            Maybe.of(
                formatDistanceStrict(new Date(date), currentTimestamp, {
                    addSuffix: true,
                    locale,
                }),
            ),
        )
        .parse(dateStringFrom);
};
